import React from 'react'
import { StandardPage } from 'components/DefaultPages'
import { UserContext } from 'components/context'
import { useLogEvent } from 'components/hooks'

const ConsentSuccess = () => {
  const { membership } = React.useContext(UserContext)
  useLogEvent('update_consent', membership)

  return (
    <StandardPage
      headerI18nKey={'pages.consents.success.title'}
      infoI18nKey={'pages.consents.success.info'}
      type={'success'}
    />
  )
}

export default ConsentSuccess
